<template>
  <auth-layout :fiftyPercentWidth="true">
    <signup-form />
  </auth-layout>
</template>

<script>
import SignupForm from "./SignupForm";
import AuthLayout from "../Authlayout/AuthLayout";
export default {
  components: {
    SignupForm,
    AuthLayout,
  },
  data() {
    return {
      isBasicDetailsFormField: true,
      isAuthFormField: false,
    };
  },
};
</script>

<style scoped>
.signup-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* margin: 2rem 0; */
}
.logo-container {
  display: flex;
  justify-content: center;
  /* padding: 1.5rem 0; */
}
.signup-content-card {
  margin-top: 2rem;
}
@media screen and (max-width: 768px) {
  .signup-content-card {
    width: 90%;
  }
  .p-sm {
    padding: 1rem 0.5rem;
  }
}
</style>